import { motion } from "framer-motion";
import { resolveImage } from "@/lib/api";

const JuiceCard = ({ juice, index }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-60px" }}
    transition={{ duration: 0.55, delay: (index % 3) * 0.1 }}
    className="group relative bg-white rounded-3xl overflow-hidden border border-[#1A1A1A]/5 shadow-[0_10px_30px_rgba(26,26,26,0.06)] hover:-translate-y-2 hover:shadow-[0_24px_44px_rgba(255,122,26,0.22)] transition-all duration-300 ease-out"
    data-testid={`juice-card-${index}`}
  >
    <div className="relative h-56 overflow-hidden">
      {resolveImage(juice.image_url) ? (
        <img
          src={resolveImage(juice.image_url)}
          alt={juice.name}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
      ) : (
        <div className="w-full h-full bg-gradient-to-br from-[#FFC93C] to-[#FF7A1A]" />
      )}
      <div className="absolute top-3 right-3">
        {juice.available ? (
          <span className="bg-[#7ED321] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow" data-testid={`juice-badge-available-${index}`}>
            Available
          </span>
        ) : (
          <span className="bg-[#FF3D68] text-white text-xs font-bold px-3 py-1.5 rounded-full shadow" data-testid={`juice-badge-soldout-${index}`}>
            Sold Out
          </span>
        )}
      </div>
    </div>

    <div className="p-6">
      <div className="flex items-start justify-between gap-3">
        <h3 className="font-display font-extrabold text-2xl text-[#1A1A1A] leading-tight">{juice.name}</h3>
        <span className="font-display font-extrabold text-2xl text-[#FF7A1A] whitespace-nowrap">{juice.price}</span>
      </div>
      {juice.size && <p className="text-xs font-semibold text-[#1A1A1A]/40 uppercase tracking-wide mt-1">{juice.size}</p>}
      <p className="mt-3 text-[15px] text-[#1A1A1A]/70 leading-relaxed">{juice.description}</p>

      {juice.ingredients && (
        <div className="mt-4 flex flex-wrap gap-2">
          {juice.ingredients.split(",").map((ing, i) => (
            <span key={i} className="text-xs font-medium bg-[#FFF8F0] border border-[#FFC93C]/40 text-[#1A1A1A]/70 px-2.5 py-1 rounded-full">
              {ing.trim()}
            </span>
          ))}
        </div>
      )}
    </div>
  </motion.div>
);

const JuicesSection = ({ juices }) => (
  <section id="juices" className="relative py-20 sm:py-28 scroll-mt-20" data-testid="juices-section">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-12 max-w-2xl"
      >
        <span className="font-display font-extrabold text-[#FF3D68] text-sm tracking-[0.2em] uppercase">01 — The Menu</span>
        <h2 className="mt-3 font-display font-extrabold text-4xl sm:text-5xl tracking-tight text-[#1A1A1A]">
          This week's <span className="text-[#FF7A1A]">fresh pressed</span> lineup
        </h2>
        <p className="mt-4 text-lg text-[#1A1A1A]/70">Pressed to order, bottled the same day. Grab your favorites before they sell out.</p>
      </motion.div>

      {juices.length === 0 ? (
        <p className="text-[#1A1A1A]/50" data-testid="juices-empty">No juices available right now. Check back soon!</p>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-testid="juices-grid">
          {juices.map((j, i) => (
            <JuiceCard key={j.id} juice={j} index={i} />
          ))}
        </div>
      )}
    </div>
  </section>
);

export default JuicesSection;
